<template>
	<div class="col-md-4 col-sm-6 col-xs-12">
		<div class="types-box clearfix">
			<span class="type-icon">
				<i class="fa" :class="item.icon" />
			</span>
			<router-link :to="{ name: 'requestTypesDetail', params: { code: item.id } }" class="type-name">
				{{ item.label }}
			</router-link>
			<tooltip v-if="item.tooltip" :text="item.tooltip" />
		</div>
	</div>
</template>

<script>
const Tooltip = () => import(/* webpackPrefetch: true */ '@/components/global/Tooltip')

export default {
	name: 'TypesContainerBox',
	components: {
		Tooltip,
	},
	props: {
		item: {
			type: Object,
			required: true,
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/sections/boxes/TypesContainerBox.vue